import { render, staticRenderFns } from "./hzhome.vue?vue&type=template&id=48df5243&"
import script from "./hzhome.vue?vue&type=script&lang=ts&"
export * from "./hzhome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports